import { WRModals } from '~/components/wr-modals/wr-modals-container';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { apiPut, hideLoader, showLoader, handleApiError } from '../../common';

export default class AdminUtils {
  static promptForNewName(item, updateCallback) {
    const promptText = `Rename ${AssetPickerTypes.getDisplayName(item.type)}`;

    const nameKey = item.type === AssetPickerTypes.GUIDE ? 'displayTitle' : 'name';
    WRModals.prompt(promptText, 'Enter a name', item[nameKey], (name) => {
      if (name && name.trim()) {
        const saveableNameKey = item.type === AssetPickerTypes.GUIDE ? 'title' : 'name';
        const data = {};
        data[saveableNameKey] = name;

        showLoader();
        apiPut(
          AssetPickerTypes.getUpdateItemUrl(item),
          data,
          () => {
            hideLoader();
            updateCallback();
          },
          handleApiError(),
        );
      }
    });
  }
}
